import { z } from 'zod';
import { HexColor, Id, IsoDate, UserRefSchema } from './common';
/* ============================================================================
   Sticky boards (PLAN §8): boards per project, frames, stickies, convert → mission
   ========================================================================== */
export const STICKY_COLORS = ['#fde68a', '#fbcfe8', '#bfdbfe', '#bbf7d0', '#ddd6fe'];
export const StickyBoardSchema = z.object({
    id: Id,
    workspaceId: Id,
    projectId: Id.nullable(),
    name: z.string(),
    stickyCount: z.number().int().nonnegative(),
    updatedAt: IsoDate,
    createdAt: IsoDate,
});
export const BoardFrameSchema = z.object({
    id: Id,
    title: z.string(),
    x: z.number(),
    y: z.number(),
    w: z.number(),
    h: z.number(),
});
export const StickySchema = z.object({
    id: Id,
    frameId: Id.nullable(),
    text: z.string(),
    color: HexColor,
    x: z.number(),
    y: z.number(),
    w: z.number(),
    h: z.number(),
    z: z.number().int(),
    linkedMission: z.object({ id: Id, key: z.string(), title: z.string() }).nullable(),
    createdBy: UserRefSchema,
    updatedAt: IsoDate,
});
export const BoardDetailSchema = StickyBoardSchema.extend({
    frames: z.array(BoardFrameSchema),
    stickies: z.array(StickySchema),
});
export const BoardCreateSchema = z.object({
    workspaceId: Id,
    projectId: Id.nullable(),
    name: z.string().trim().min(1).max(60),
});
export const BoardUpdateSchema = z.object({ name: z.string().trim().min(1).max(60) });
export const BoardDeleteSchema = z.object({ confirmName: z.string() });
export const BoardClearSchema = z.object({ confirm: z.literal('clear') });
export const FrameUpsertSchema = z.object({
    title: z.string().trim().min(1).max(60),
    x: z.number(),
    y: z.number(),
    w: z.number().positive(),
    h: z.number().positive(),
});
export const FramePatchSchema = FrameUpsertSchema.partial();
export const StickyCreateSchema = z.object({
    text: z.string().max(2000).default(''),
    color: HexColor,
    x: z.number(),
    y: z.number(),
    w: z.number().positive().default(180),
    h: z.number().positive().default(160),
    frameId: Id.nullable().optional(),
});
export const StickyPatchSchema = z.object({
    text: z.string().max(2000).optional(),
    color: HexColor.optional(),
    x: z.number().optional(),
    y: z.number().optional(),
    w: z.number().positive().optional(),
    h: z.number().positive().optional(),
    z: z.number().int().optional(),
    frameId: Id.nullable().optional(),
});
/** Batch position updates while dragging (debounced client-side). */
export const StickyBatchMoveSchema = z.object({
    moves: z
        .array(z.object({ id: Id, x: z.number(), y: z.number(), z: z.number().int().optional() }))
        .min(1)
        .max(200),
});
export const StickyConvertSchema = z.object({
    projectId: Id,
    title: z.string().trim().min(1).max(300),
    statusId: Id.optional(),
    assigneeIds: z.array(Id).optional(),
    dueAt: z
        .string()
        .regex(/^\d{4}-\d{2}-\d{2}$/)
        .nullable()
        .optional(),
    priority: z.enum(['urgent', 'high', 'normal', 'low']).optional(),
});
//# sourceMappingURL=boards.js.map